import closeGlyph from '@images/10years/stories/ico-close-small.svg';
import { useTranslations } from 'next-intl';
import { TrackedButton } from '@/components/button/tracked-button';
import { PANEL_SHAPE, TEN_YEARS_POSITION } from '../../_const/stories';
import ChevronButton from '../../_components/chevron-button';

// 모달 전용 부품. motion 을 쓰지 않아 임시 모달(첫 로드 번들)이 가져와도 모달 코드가 딸려 오지 않는다

// 모달 바깥 래퍼. 라우트 모달과 임시 모달이 같은 값을 써야 교체가 보이지 않는다
export const DIALOG_CLASS = {
  scroller:
    'fixed inset-0 m-0 h-full max-h-none w-full max-w-none overflow-y-auto bg-transparent p-0 backdrop:bg-transparent',
  backdrop: 'fixed inset-0 bg-[rgba(10,22,33,0.6)]',
  panel: `relative min-h-full lg:my-10 lg:min-h-0 ${PANEL_SHAPE}`,
};

/** 닫기·이전/다음 버튼. 라우트 모달과 임시 모달(핸들러 없이 inert 안)이 같이 쓴다 */
export function StoryDialogControls({
  onClose,
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
}: {
  onClose?: () => void;
  onPrev?: () => void;
  onNext?: () => void;
  prevDisabled: boolean;
  nextDisabled: boolean;
}) {
  const t = useTranslations('TenYears.stories.modal');
  return (
    <>
      {/* 첫 포커스 대상이 되도록 DOM 맨 앞에 둔다 */}
      <TrackedButton
        type="button"
        label="10years-stories-modal-close"
        position={TEN_YEARS_POSITION}
        aria-label={t('close')}
        onClick={onClose}
        className="absolute right-5 top-5 z-10 flex size-8 items-center justify-center rounded-full bg-3b-blue-light-900 text-white lg:right-12 lg:top-12 lg:size-12"
      >
        <span
          aria-hidden
          className="block size-4 bg-current lg:size-6"
          style={{ mask: `url(${closeGlyph.src}) center / contain no-repeat` }}
        />
      </TrackedButton>
      {/* 16:9 미디어(56.25vw) 바로 아래 */}
      <div className="absolute right-5 top-[calc(56.25vw+20px)] z-10 flex gap-3 lg:right-10 lg:top-[580px]">
        <ChevronButton
          direction="prev"
          label={t('prev')}
          trackLabel="10years-stories-modal-prev"
          disabled={prevDisabled}
          onClick={onPrev}
        />
        <ChevronButton
          direction="next"
          label={t('next')}
          trackLabel="10years-stories-modal-next"
          disabled={nextDisabled}
          onClick={onNext}
        />
      </div>
    </>
  );
}
